var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "news_w" }, [
    _c("div", { staticClass: "courseL" }, [
      _c("div", { staticClass: "list" }, [
        _c("div", { staticClass: "tips" }, [
          _vm._v("当前位置： "),
          _c("span", { on: { click: _vm.toCom } }, [_vm._v("赛事专栏")]),
          _vm._v(" > 作品展示"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "main" }, [
          _c("div", { staticClass: "oneVideo" }, [
            _c("div", { staticClass: "vid" }, [
              _c("video", {
                ref: "skVideo2",
                attrs: {
                  src: "https://file.icve.com.cn/file_doc/615/549/99D894CC133EDDA50C06A842A4DB96C4.mp4",
                  controls: "controls",
                  controlslist: "nodownload",
                },
              }),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tab" },
            _vm._l(_vm.tabList, function (i, j) {
              return _c(
                "div",
                {
                  staticClass: "item",
                  class: { active: _vm.curIndex == j },
                  on: {
                    click: function ($event) {
                      return _vm.tabs(i, j)
                    },
                  },
                },
                [_vm._v(_vm._s(i))]
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "det" }, [
      _c("div", { staticClass: "tit" }, [_vm._v("常莹主题班会实录视频")]),
      _vm._v(" "),
      _c("div", { staticClass: "intro" }, [
        _vm._v(
          "作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍作品详情介绍"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }